import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    accountant: {
      subtitle: 'There are no transactions on this wallet yet.',
    },
    accountHolder: {
      subtitle:
        'When your first transactions will be made, they will appear here.',
      title: 'You do not have any transactions yet',
    },
    companyUser: {
      subtitle:
        'When {name}’s first transactions will be made, they will appear here.',
      title: '{name} does not have any transactions yet',
    },
    employee: {
      subtitle:
        'This is where you will find all your transactions\nonce your card has been ordered or your first transfer has been executed.',
      title: 'No transaction',
    },
    helpText: {
      allTransactions:
        'This is where you’ll find your transactions\nas soon as you start using your account.',
      default:
        'This is where you will find all of {companyName}’s account transactions.',
      onlyOwnTransactions:
        'This is where you will find all your transactions\nonce your card has been ordered and activated.',
    },
    isInitiator: {
      subtitle:
        'When your first transactions will be made, they will appear here.',
      title: 'You do not have any transactions yet',
    },
    requestNewCard: 'Request a new card',
  },
  fr: {
    accountant: {
      subtitle: 'll n’y a aucune transaction sur ce compte pour le moment.',
    },
    accountHolder: {
      subtitle:
        'Dès que vous aurez réalisé vos premières transactions, elles apparaîtront ici.',
      title: 'Vous n’avez pas encore de transaction',
    },
    companyUser: {
      subtitle:
        'Dès que {name} aura réalisé ses premières transactions, elles apparaîtront ici.',
      title: '{name} n’a pas encore de transaction',
    },
    employee: {
      subtitle:
        'C’est ici que vous trouverez l’ensemble de vos transactions\nune fois votre carte commandée ou votre premier virement réalisé.',
      title: 'Aucune transaction',
    },
    helpText: {
      allTransactions:
        'C’est ici que vous trouverez vos transactions bancaires\ndès que vous commencerez à utiliser votre compte.',
      default:
        'C’est ici que vous trouverez l’ensemble des\ntransactions du compte de {companyName}.',
      onlyOwnTransactions:
        'C’est ici que vous trouverez l’ensemble de vos transactions\nune fois votre carte commandée et active.',
    },
    isInitiator: {
      subtitle:
        'Dès que vous aurez réalisé vos premières transactions, elles apparaîtront ici.',
      title: 'Vous n’avez pas encore de transaction',
    },
    requestNewCard: 'Demander une nouvelle carte',
  },
} as const);

export default locales;
